import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from "firebase/functions";


const firebaseConfig = {
  apiKey: "AIzaSyAMKmYa3XDMbOVR1gqlrHcKeMjhxMcRM1I",
  authDomain: "capital-project-e5d37.firebaseapp.com",
  projectId: "capital-project-e5d37",
  storageBucket: "capital-project-e5d37.firebasestorage.app",
  messagingSenderId: "583493103403",
  appId: "1:583493103403:web:8ce392923068b215a35f6e"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);